// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ControlOutlinedSvg from "@fishx/icons-svg/es/asn/ControlOutlined";
import FishxIcon from '../components/FishxIcon';

var ControlOutlined = function ControlOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ControlOutlinedSvg
  }));
};

ControlOutlined.displayName = 'ControlOutlined';
export default React.forwardRef(ControlOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ControlOutlined.js
// module id = 2324
// module chunks = 0